import React, { useEffect } from "react";
import Image from "components/image";
import ArrowRight from "images/arrow-right-green.png";

const Benefits = ({ data }) => {
  return (
    <div className="container sm:max-w-[260px] sm:mx-auto">
      <div className="flex items-center flex-col">
        <p className="header">{data.title}</p>
        <p className="m-[16px] sm:mx-0 text-gray-600">{data.description}</p>
      </div>

      <div className="flex justify-center mt-14 sm:mt-11">
        <div className="grid grid-cols-3 gap-6 sm:grid-cols-1 w-full max-w-[820px] mx-auto">
          {data.benefits.map((benefit, index) => (
            <div className="group h-52" key={index}>
              <div className="h-full border border-gray-300 bg-gray-200 flex flex-col items-center justify-center sm:px-9">
                <div className=" flex justify-center items-center flex-col max-w-[130px] sm:max-w-full ">
                  <div className="rounded-full overflow-hidden w-[100px] h-[100px] mb-[12px]">
                    <img src={benefit.icon.src} className="w-full h-full" />
                  </div>
                  <p className="font-sans font-medium text-sm text-center">
                    {benefit.description}
                  </p>
                  <button className="hidden sm:flex group-hover:flex items-center justify-center underline mt-3">
                    Learn more{" "}
                    <img
                      src={ArrowRight}
                      alt="arrow right"
                      className="w-6 h-6"
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
